import { useSelector } from 'react-redux'
import { useFeatureFlagEnabled } from 'posthog-js/react'

import { selectCurrentEnterprise } from '@/store/features/user/userSlice'

// Hides seat-type UI from customers until Product approves the seat-management launch.
export const SEAT_MANAGEMENT_FLAG = 'notetaker-seat-controls'

export const useSeatManagementEnabled = (): boolean => useFeatureFlagEnabled(SEAT_MANAGEMENT_FLAG) === true

/** Whether seat-type UI applies to the current organization; callers still decide who may see or edit it. */
export const useSeatSelectionEnabled = (): boolean => {
  const seatManagementEnabled = useSeatManagementEnabled()
  const enterprise = useSelector(selectCurrentEnterprise)

  return seatManagementEnabled && enterprise?.seatSelectionEnabled === true
}
